var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stitched-outfits-container"},[_c('RemoveOutfitModal'),_vm._v(" "),(!_vm.outfitsLoaded)?_c('LoadingProducts'):_c('div',[_c('BoxLayoutList',{attrs:{"outfits":_vm.wardrobeOutfits}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3277c532","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Users/Wardrobe/WardrobeOutfits.vue
// module id = N3Oq
// module chunks = 0